import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { TARGETS as orderTargets } from '~redux/Order/constants';

import { getFilteredItems } from './utils';

export const useFilteredCartItems = () => {
  const menu = useSelector((state) => state.menu.menu);
  const cartItems = useSelector((state) => state.cart.cart);
  const futureOrder = useSelector((state) => state.order[orderTargets.FUTURE_ORDER]);

  const items = useMemo(() => getFilteredItems({ cartItems, menu, futureOrder }), [
    cartItems,
    futureOrder,
    menu
  ]);
  const modifiers = useMemo(() => getFilteredItems({ cartItems, menu, searchModifiers: true, futureOrder }), [
    cartItems,
    futureOrder,
    menu
  ]);

  return { items, modifiers, cartItems };
};
